<div class="wrapping">
  <app-card>
    <div class="loader">
      <div class="cell cell-1"><span class="fa-thin fa-gear"></span></div>
      <div class="cell cell-2"><span class="fa-regular fa-gear"></span></div>
      <div class="cell cell-3"><span class="fa-solid fa-gear"></span></div>
    </div>
    <span class="text">{{'under-construction' | translate}}</span>
  </app-card>

</div>
